module.exports = __webpack_public_path__ + "img/new_left_slogan.0e4be154.png";